// extracted by mini-css-extract-plugin
export default {"containerClose":"Accordion_containerClose__UgoU6","containerOpen":"Accordion_containerOpen__hpZcJ"};